import { render, staticRenderFns } from "./sunu_devis_liste.vue?vue&type=template&id=4cf87a9d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./sunu_devis_liste.vue?vue&type=script&lang=js"
export * from "./sunu_devis_liste.vue?vue&type=script&lang=js"
import style0 from "./sunu_devis_liste.vue?vue&type=style&index=0&id=4cf87a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf87a9d",
  null
  
)

export default component.exports